import { render } from "./Test.vue?vue&type=template&id=59f2255e"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import "./Test.vue?vue&type=style&index=0&id=59f2255e&lang=css"
script.render = render

export default script